import React, { useEffect, useState } from "react";
import { Table, Button } from "reactstrap";
import style from "../Bulk/Bulk.module.scss";
import Edit from "./Edit";
import { FormattedNumber } from "../../../../FormattedNumber/FormattedNumber";

const Securities = ({ error, items, isCurrency, readonly, dispatch, ...props }) => {
  const [edit, setEdit] = useState({
    open: false,
    item: { IsCurrency: isCurrency },
  });

  const toggleEdit = (item = { IsCurrency: isCurrency }) => {
    setEdit({
      open: !edit.open,
      item,
    });
  };

  const onEdit = (item) => {
    dispatch({ type: "EDIT_BULK_ITEM", item });
  };

  const onDelete = (itemId) => {
    dispatch({ type: "DELETE_BULK_ITEM", itemId });
  };

  if (edit.open) {
    return (
      <React.Fragment>
        <Edit
          accountId={props.accountId}
          toggle={toggleEdit}
          item={edit.item}
          edit={onEdit}
          fetchSearchSymbol={props.services.fetchSearchSymbol}
          fetchGetAssetInformation={props.services.fetchGetAssetInformation}
        />
      </React.Fragment>
    );
  }

  return (
    <React.Fragment>
      <div style={{ marginTop: "10px" }}>
        <span className={style.title}>Securities</span>
        <React.Fragment>
          <Button
            color="primary"
            style={{ marginTop: "2px" }}
            className={`${style.btnAdd} btn-sm`}
            onClick={() => toggleEdit()}
            disabled={readonly}
          >
            <i className="fa fa-plus"></i>
            {"\u00A0"} Add Security
          </Button>
          <div className={`${style.table} ${error ? style.error : ""}`}>
            <Table responsive striped>
              <thead>
                <tr>
                  <th></th>
                  <th>Quantity</th>
                  <th>Price</th>
                  <th>Security</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {items
                  .filter((i, ind) => i.Quantity != null)
                  .map((i, ind) => (
                    <Item
                      key={`r-${i.Id}-${ind}`}
                      item={i}
                      onDelete={() => onDelete(i.Id)}
                      onEdit={() => toggleEdit(i)}
                      readonly={readonly}
                      accountType={props.accountType}
                    />
                  ))}
              </tbody>
            </Table>
          </div>
          {error && (
            <div className={`invalid-feedback`} style={{ display: "block" }}>
              {error}
            </div>
          )}
        </React.Fragment>
      </div>
    </React.Fragment>
  );
};

const Item = ({ item, readonly, onDelete, onEdit }) => {
  return (
    <tr>
      <td>{item.IsCurrency ? "C" : "A"}</td>
      <td className="text-right">
        <FormattedNumber value={item.Quantity} dataTypeDecimalName="quantity" />
      </td>
      <td className="text-right">
        <FormattedNumber value={item.Price} decimalScale={item.decimal} dataTypeDecimalName="price" />
      </td>
      <td>{item.IsCurrency ? item.CurrencyISO : item.AssetTicker}</td>
      <td>
        <Button color="btn-outline-primary btn-sm" disabled={readonly} onClick={() => onEdit()}>
          <i className="fa fa-pencil"></i>
        </Button>
        <Button
          color="btn-outline-primary btn-sm"
          disabled={readonly}
          onClick={() => onDelete(item.Id)}
          style={{ color: "#d83737" }}
        >
          <i className="fa fa-trash"></i>
        </Button>
      </td>
    </tr>
  );
};

export default Securities;
